import { render, staticRenderFns } from "./CopyDataset.vue?vue&type=template&id=559a1e45&"
import script from "./CopyDataset.vue?vue&type=script&lang=js&"
export * from "./CopyDataset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports